import { render, staticRenderFns } from "./OneToOne.vue?vue&type=template&id=ed214eee&scoped=true"
import script from "./OneToOne.vue?vue&type=script&lang=js"
export * from "./OneToOne.vue?vue&type=script&lang=js"
import style0 from "./OneToOne.vue?vue&type=style&index=0&id=ed214eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed214eee",
  null
  
)

export default component.exports